var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.med)?_c('div',[_c('v-text-field',{attrs:{"label":_vm.$t('medkitlogs.whatWasUsed'),"data-cy":"medUsed","rules":_vm.requieredRule},model:{value:(_vm.value.medUsed),callback:function ($$v) {_vm.$set(_vm.value, "medUsed", $$v)},expression:"value.medUsed"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }